const IMAGE_EXT = /\.(jpe?g|png|gif|webp|heic|heif|bmp|svg)$/i;

export const getRentalFileName = (file, saved) =>
  file?.name || saved?.fileName || saved?.name || "Document";

export const isRentalImageFile = (file, saved) => {
  const type = (file?.type || saved?.contentType || "").toLowerCase();
  if (type.startsWith("image/")) return true;
  const name = getRentalFileName(file, saved).toLowerCase();
  return IMAGE_EXT.test(name);
};

export const getRentalFileUrl = (file, saved) => {
  if (file) return "";
  return saved?.url || "";
};

export const isRentalPdfFile = (file, saved) => {
  const type = (file?.type || saved?.contentType || "").toLowerCase();
  if (type === "application/pdf") return true;
  const name = getRentalFileName(file, saved).toLowerCase();
  return name.endsWith(".pdf");
};
